'use strict';

export function createSynchronizable(_initialValue, _config) {
  throw new Error('[Worklets] `createSynchronizable` is not supported on web.');
}
//# sourceMappingURL=synchronizable.js.map